import React from 'react';
import PropTypes from 'prop-types';
import AvailableLanguageLink from '../AvailableLanguageLink';
import { Link } from 'src/components/Inputs';
import Image from 'src/components/Image';

const propTypes = {
  id: PropTypes.string,
  availableLanguages: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
};

const FrVersion = ({ availableLanguages }) => {
  return (
    <>
      <h4 id='avis-de-confidentialité-du-candidat'>
        Avis de confidentialité du Candidat (mondial)
      </h4>

      <p>Langues disponibless:</p>
      <ul>
        {availableLanguages.map((language, i) => {
          return (
            <AvailableLanguageLink
              key={`language-${i}`}
              href={language.href}
              label={language.label}
            />
          );
        })}
      </ul>
      <br />
      <br />

      <p>Date d’entrée en vigueur : 1 février 2024</p>
      <p>
        Chez Plaid, nous comprenons l’importance de la confidentialité et de la
        transparence. Le présent Avis de confidentialité des Candidats (« Avis
        ») a pour but d’expliquer comment Plaid Inc. et ses filiales, y compris
        Plaid Financial Ltd. et Plaid, B.V. (collectivement, « Plaid », « nous
        », « notre » ou « nos »), collectent, utilisent et partagent des données
        et informations à caractère personnel provenant de et concernant des
        candidats potentiels (« vous » ou « votre ») pour des postes chez Plaid
        (« Informations relatives au Candidat »).
      </p>
      <p>
        Veuillez noter que si vous soumettez votre CV ou d’autres Informations
        relatives au Candidat via notre site Web, nous pouvons également
        collecter et traiter des informations sur vous en lien avec votre accès
        ou à votre utilisation du site Web de Plaid. Vous trouverez des
        informations supplémentaires concernant notre utilisation de vos données
        dans notre Déclaration de confidentialité. Vous trouverez des
        informations supplémentaires sur notre site Web sur les types de cookies
        que nous utilisons, la raison pour laquelle nous les utilisons et la
        manière dont vous pouvez contrôler ou limiter l’utilisation des cookies
        dans notre{' '}
        <Link href='#politique-relative-aux-cookies'>
          <a>Politique relative aux cookies</a>
        </Link>
        .
      </p>
      <p>
        <em>Aller à la section :</em>
      </p>
      <p>
        <Link href='#nos-pratiques-en-matière-de-données-confidentialité-du-Candidat'>
          <a data-smooth-scroll data-offset='80'>
            Nos pratiques en matière de données
          </a>
        </Link>
      </p>

      <ul data-smooth-scroll data-offset='80'>
        <li>
          <p>
            <Link href='#données-que-nous-collectons-confidentialité-du-Candidat'>
              <a>Données que nous collectons</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#l’utilisation-que-nous-faisons-de-vos-données-confidentialité-du-Candidat'>
              <a>L’utilisation que nous faisons de vos données</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#comment-nous-divulguons-vos-informations-confidentialité-du-Candidat'>
              <a>Comment nous divulguons vos informations</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#nos-bases-légales-pour-le-traitement-confidentialité-du-Candidat'>
              <a>
                Nos bases légales pour le traitement (candidats au Royaume-Uni
                et dans l’EEE uniquement)
              </a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#nos-pratiques-de-conservation-confidentialité-du-Candidat'>
              <a>Nos pratiques de conservation</a>
            </Link>
          </p>
        </li>
      </ul>

      <p>
        <Link href='#autres-informations-confidentialité-du-Candidat'>
          <a data-smooth-scroll data-offset='80'>
            Autres informations
          </a>
        </Link>
      </p>

      <ul data-smooth-scroll data-offset='80'>
        <li>
          <p>
            <Link href='#transferts-internationaux-de-données-confidentialité-du-Candidat'>
              <a>Transferts internationaux de données</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#droits-de-protection-des-données-des-candidats-californiens'>
              <a>Droits de protection des données des candidats californiens</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#droits-de-protection-des-données-des-candidats'>
              <a>
                Droits de protection des données des candidats au Royaume-Uni,
                dans l’EEE et au Canada
              </a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#modifications-apportées-au-présent-avis-confidentialité-du-Candidat'>
              <a>Modifications apportées au présent Avis</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#contacter-plaid-confidentialité-du-Candidat'>
              <a>Contacter Plaid</a>
            </Link>
          </p>
        </li>
      </ul>
      <br />
      <br />

      <h4 id='nos-pratiques-en-matière-de-données-confidentialité-du-Candidat'>
        Nos pratiques en matière de données
      </h4>

      <h5 id='données-que-nous-collectons-confidentialité-du-Candidat'>
        Données que nous collectons
      </h5>
      <p>
        Nous collectons les Informations relatives au Candidat fournies par (1)
        vous, y compris par le biais de la page Carrières de Plaid (disponible à
        l’adresse https://plaid.com/careers/), (2) des tiers, tels que des
        prestataires de vérification des antécédents, des consultants en
        recrutement ou des agences de recrutement professionnelles, ou (3) la
        société Plaid elle-même par le biais de recherches sur les candidats.
        Nous pouvons également obtenir des Informations relatives au Candidat en
        créant un profil reflétant vos préférences, caractéristiques,
        comportement, renseignements, capacités et aptitudes en matière
        d’emploi, par exemple par le biais de notes prises dans le cadre du
        processus d’entretien.
      </p>
      <p>
        Nous collectons les catégories suivantes d’Informations relatives au
        Candidat concernant les Candidats pour lesquels nous envisageons pour
        des postes:
      </p>
      <ul>
        <li>
          <p>
            <u>identifiants et coordonnées</u>, y compris votre nom complet,
            adresse, numéro de téléphone, adresse e-mail ou autres coordonnées;
          </p>
        </li>
        <li>
          <p>
            <u>informations professionnelles ou liées à l’emploi</u>, y compris
            les informations contenues dans votre CV ; vos antécédents
            professionnels, certifications, licences professionnelles et autres
            expériences ; et les coordonnées de votre ancien employeur/employeur
            actuel (lorsque ces informations contiennent vos données à caractère
            personnel);
          </p>
        </li>
        <li>
          <p>
            <u>informations sur l’éducation</u>, y compris des informations sur
            vos diplômes et votre formation, des relevés de notes et résultats
            scolaires;
          </p>
        </li>
        <li>
          <p>
            <u>informations sur les réseaux sociaux et similaires</u>,telles que
            les informations sur les réseaux sociaux et de profil public, y
            compris les URL liées à vos profils LinkedIn, Twitter, GitHub et
            Portfolio, et votre site Web personnel;
          </p>
        </li>
        <li>
          <p>
            <u>
              dans certaines régions (comme les États-Unis), nous pouvons
              recueillir des informations démographiques et autres informations
              sensibles (par ex., race, sexe, statut d’ancien combattant,
              origine ethnique, orientation sexuelle et statut d’invalidité)
            </u>
            ; et
          </p>
        </li>
        <li>
          <p>
            <u>autres informations que vous soumettez</u>, y compris des
            informations supplémentaires fournies dans un formulaire de demande,
            une lettre de candidature ou un autre produit du travail.
          </p>
        </li>
      </ul>

      <p>
        Si votre candidature progresse, nous recueillerons également les
        informations suivantes relatives au Candidat:
      </p>
      <ul>
        <li>
          <p>
            <u>
              informations recueillies dans le cadre du processus d’entretien
            </u>
            , telles que les notes prises lors de votre entretien (lorsqu’elles
            contiennent vos données à caractère personnel) ; et les données à
            caractère personnel incluses dans tout projet à emporter;
          </p>
        </li>
        <li>
          <p>
            <u>
              informations nécessaires à la planification de votre entretien
            </u>
            , y compris les identifiants tels que votre adresse, votre numéro
            Known Traveler et les informations relatives aux voyageurs
            fréquents;
          </p>
        </li>
        <li>
          <p>
            <u>données audio et visuelles</u>, notamment les photographies pour
            les profils de travail et les images de sécurité recueillies dans
            les locaux de Plaid.
          </p>
        </li>
        <li>
          <p>
            <u>
              informations sur l’activité du réseau électronique et les données
              d’utilisation
            </u>
            , y compris votre utilisation des équipements, appareils, logiciels
            et autres actifs de Plaid.
          </p>
        </li>
        <li>
          <p>
            <u>détails sur les attentes en matière d’emploi</u>, y compris, dans
            la mesure où elles contiennent vos données à caractère personnel, le
            type d’emploi recherché, les attentes en matière de rémunération, la
            volonté de déménager et autres préférences professionnelles;
          </p>
        </li>
        <li>
          <p>
            <u>
              (si et dans la mesure où cela est pertinent pour un rôle
              spécifique) les informations nécessaires pour effectuer une
              vérification des antécédents
            </u>
            , telles que les informations obtenues soit auprès de vous, soit par
            le biais de vérifications des références et des antécédents, sous
            réserve de toute autre autorisation ou notification requise et/ou
            autorisée par la loi applicable, généralement en fournissant un
            Certificat de bonne conduite officiel (par exemple aux Pays-Bas :
            Verklaring Omtrent Gedrag ou VOG) ; et
          </p>
        </li>
        <li>
          <p>
            <u>informations requises pour démarrer un emploi</u>, y compris la
            preuve de l’éligibilité à travailler dans un pays spécifié (tel
            qu’un passeport ou un visa) ; des informations démographiques telles
            que votre date et votre lieu de naissance, et la citoyenneté ; des
            identifiants tels que votre numéro de sécurité sociale (lorsque la
            loi l’exige et/ou l’autorise), numéro d’assurance nationale, un
            autre identifiant émis par le gouvernement, identifiants fiscaux et
            informations fiscales connexes (lorsque la loi l’exige et/ou
            l’autorise), et les numéros de compte bancaire et les informations
            connexes ; informations sur l’éligibilité aux avantages sociaux ; et
            autres informations que vous fournissez aux fins de commencer à
            travailler ou d’exécuter un contrat de travail.
          </p>
        </li>
      </ul>

      <h5 id='l’utilisation-que-nous-faisons-de-vos-données-confidentialité-du-Candidat'>
        L’utilisation que nous faisons de vos données
      </h5>
      <p>
        Nous utilisons les Informations relatives au Candidat recueillies à
        votre sujet pour traiter votre candidature et pour nous conformer aux
        obligations légales que nous avons en lien avec votre candidature, y
        compris pour confirmer votre éligibilité à travailler dans un lieu
        donné.
      </p>
      <p>
        Nous utiliserons également les Informations relatives au Candidat vous
        concernant aux fins suivantes:
      </p>
      <ul>
        <li>
          <p>
            <u>administrer et traiter votre candidature</u>, y compris vérifier
            votre identification, votre expérience et d’autres informations que
            vous soumettez et, si votre candidature progresse, toute information
            d’entretien et de vérification des antécédents;
          </p>
        </li>
        <li>
          <p>
            <u>communiquer avec vous au sujet de votre candidature</u>, y
            compris vous contacter par téléphone, par e-mail ou sur les
            plateformes de réseaux sociaux au sujet de votre candidature et, si
            votre candidature progresse, coordonner tout entretien et
            vérification des antécédents;
          </p>
        </li>
        <li>
          <p>
            <u>
              évaluer votre adéquation au poste pour lequel vous avez postulé,
              ou pour d’autres postes vacants
            </u>
            , y compris vérifier votre identification, votre expérience et
            d’autres informations que vous soumettez et, si votre candidature
            progresse, toute information d’entretien et de vérification des
            antécédents;
          </p>
        </li>
        <li>
          <p>
            <u>
              effectuer des vérifications des références et des antécédents, y
              compris des vérifications du casier judiciaire, dans le cadre de
              votre candidature
            </u>
            , sous réserve de la loi applicable, y compris la vérification de
            votre identification, de votre expérience et d’autres informations
            que vous soumettez et, si votre candidature progresse, toute
            information d’entretien et de vérification des antécédents;
          </p>
        </li>
        <li>
          <p>
            <u>
              respecter les lois applicables et les exigences liées à l’emploi
            </u>
            , y compris vérifier les informations d’identification et les
            informations requises pour démarrer l’emploi, à des fins telles que
            la confirmation de la capacité à travailler légalement dans un lieu
            spécifique, la mise en place de la paie, des retenues et des
            avantages sociaux, et le respect des exigences légales en matière de
            déclaration;
          </p>
        </li>
        <li>
          <p>
            <u>améliorer notre processus de recrutement</u>, comme le permet la
            loi applicable et uniquement dans certaines régions (comme les
            États-Unis), y compris en générant des analyses à l’aide des
            Informations relatives au Candidat pour nous assurer de recruter un
            ensemble diversifié de candidats;
          </p>
        </li>
        <li>
          <p>
            <u>vous informer des opportunités de carrière</u>, y compris
            d’autres postes vacants auxquels vous pourriez être éligible; et
          </p>
        </li>
        <li>
          <p>
            <u>à toute autre fin notifiée avec votre consentement</u>.
          </p>
        </li>
      </ul>
      <p>
        Veuillez noter que si vous acceptez un emploi chez Plaid, vos
        Informations relatives au Candidat feront partie de votre dossier
        d’emploi et seront utilisées à des fins d’emploi conformément à la loi
        applicable et à tout Avis de confidentialité du personnel applicable.
        Toutefois, si vous n’êtes pas accepté pour un poste, nous pouvons
        toujours conserver votre candidature, y compris les Informations
        pertinentes relatives au Candidat, pour nous permettre de vous envisager
        pour d’autres opportunités de carrière chez Plaid et à condition que, si
        les lois applicables l’exigent, nous ayons obtenu votre consentement
        préalable pour une telle conservation plus longue de vos données à
        caractère personnel. Si vous ne souhaitez pas que vos informations
        soient conservées dans le cas où un poste ne vous serait pas proposé, le
        cas échéant, veuillez vous reporter aux sections suivantes pour
        connaître les options qui peuvent être à votre disposition:{' '}
        <Link href='#droits-de-protection-des-données-des-candidats-californiens'>
          <a>Droits de protection des données des candidats californiens</a>
        </Link>{' '}
        et{' '}
        <Link href='#droits-de-protection-des-données-des-candidats'>
          <a>
            Droits de protection des données des candidats au Royaume-Uni, dans
            l’EEE et au Canada
          </a>
        </Link>
        .
      </p>
      <p>
        Plaid n’utilise pas vos données à caractère personnel pour la prise de
        décision individuelle automatisée (y compris le profilage).
      </p>

      <h5 id='comment-nous-divulguons-vos-informations-confidentialité-du-Candidat'>
        Comment nous divulguons vos informations
      </h5>
      <p>
        Nous divulguons vos données à caractère personnel à des tiers comme
        suit, ou comme décrit autrement dans le présent Avis:
      </p>
      <ul>
        <li>
          <p>
            <u>entre et parmi Plaid et nos filiales et entités affiliées</u>,
            car l’entité spécifique pour laquelle vous postulez fait partie d’un
            groupe plus large d’entreprises dont le siège social se trouve aux
            États-Unis et qui exerce dans divers pays qui partagent les
            ressources humaines et les systèmes informatiques pour traiter votre
            candidature, évaluer votre adéquation au poste et initier un emploi
            (le cas échéant);
          </p>
        </li>
        <li>
          <p>
            <u>
              avec nos sous-traitants de données et autres prestataires de
              services
            </u>
            , y compris nos prestataires de services d’analyse de données,
            prestataires de service de vérification des antécédents, agences de
            recrutement, en relation avec les services qu’ils fournissent pour
            nous ou pour notre compte. Lorsque cela est nécessaire, ces
            prestataires de services, partenaires ou fournisseurs agissant en
            notre nom seront soumis à des obligations contractuelles afin de
            mettre en œuvre des mesures techniques et organisationnelles
            appropriées pour sauvegarder les Informations relatives au Candidat,
            et de les traiter uniquement conformément aux instructions.
          </p>
        </li>
        <li>
          <p>
            <u>
              aux forces de l’ordre, aux autorités gouvernementales, aux
              régulateurs, et à d’autres tierces parties
            </u>
            , comme les tribunaux et autres autorités, aux conseillers externes
            indépendants et aux équipes internes de conformité et d’enquête, si
            cette divulgation est conforme à, ou est autrement requise par,
            toute loi, réglementation ou procédure juridique applicable;
          </p>
        </li>
        <li>
          <p>
            <u>
              en lien avec, ou pendant les négociations de toute fusion, vente
              d’actifs de la société, consolidation ou restructuration,
              financement ou acquisition de la totalité ou d’une partie de notre
              activité par ou dans une autre société dans la mesure autorisée
            </u>
            , par toute loi applicable;
          </p>
        </li>
        <li>
          <p>
            <u>si nécessaire pour protéger Plaid</u>, y compris pour établir,
            exercer ou se défendre contre des revendications juridiques
            potentielles, envisagées ou existantes;
          </p>
        </li>
        <li>
          <p>
            <u>
              pour faire appliquer tout contrat avec vous ou si nous pensons que
              vos actions sont incompatibles avec nos politiques
            </u>
            ;
          </p>
        </li>
        <li>
          <p>
            <u>
              pour répondre à toute réclamation, pour protéger nos droits ou les
              droits d’une tierce partie, pour protéger la sécurité de toute
              personne ou pour empêcher toute activité illégale
            </u>
            ; ou
          </p>
        </li>
        <li>
          <p>
            <u>
              à toute autre fin notifiée avec votre consentement ou selon vos
              instructions
            </u>
            .
          </p>
        </li>
      </ul>
      <p>
        Nous pouvons également utiliser ou divulguer des informations agrégées,
        anonymisées ou anonymisées qui ne peuvent pas raisonnablement être
        utilisées pour vous identifier, dans la mesure autorisée par la loi
        applicable.
      </p>

      <h5 id='nos-bases-légales-pour-le-traitement-confidentialité-du-Candidat'>
        Nos bases légales pour le traitement (candidats au Royaume-Uni et dans
        l’EEE uniquement)
      </h5>
      <p>
        Pour les candidats au Royaume-Uni (« Royaume-Uni ») et dans l’Espace
        économique européen (« EEE »), notre base juridique pour la collecte,
        l’utilisation et le partage des Informations relatives au Candidat
        dépendra des informations concernées et du contexte dans lequel nous les
        avons collectées ou traitées. Toutefois, nous recueillerons et
        traiterons, en général, les Informations relatives au Candidat
        uniquement dans les cas suivants:
      </p>
      <p>
        (a) nous devons nous conformer aux obligations légales qui nous sont
        applicables (comme les lois et réglementations applicables en matière
        d’immigration ou d’emploi);
      </p>
      <p>
        (b) nous avons besoin des informations pour remplir nos responsabilités
        dans tout accord réel ou potentiel avec vous (tel qu’un contrat de
        travail ou une offre d’emploi si votre candidature est envisagée);
      </p>
      <p>
        (c) le traitement est nécessaire pour nos intérêts légitimes et n’est
        pas outrepassé par vos intérêts en matière de protection des données ou
        vos droits et libertés fondamentaux (par exemple, pour assurer un
        environnement de travail sûr pour tous les membres de notre équipe), et
        pour assurer la fiabilité de nos candidats, et autrement administrer et
        traiter votre candidature ou pour communiquer avec vous au sujet de
        votre candidature; et
      </p>
      <p>
        (d) nous disposons de votre consentement pour le faire (dans les cas où
        le consentement est réellement donné librement).
      </p>
      <p>
        Lorsque nous sommes légalement autorisés ou tenus de collecter et de
        traiter des catégories particulières de données (par exemple, la race),
        nous traiterons alors uniquement ces informations:
      </p>
      <ul>
        <li>
          <p>
            lorsque nous devons raisonnablement le faire afin de nous conformer
            à nos obligations légales en tant qu’employeur potentiel;
          </p>
        </li>
        <li>
          <p>
            lorsque nous devons le faire afin d’être informés de votre capacité
            de travail;
          </p>
        </li>
        <li>
          <p>
            lorsque nous devons le faire pour protéger vos intérêts vitaux ou
            ceux d’une autre personne (et que nous ne sommes pas en mesure
            d’obtenir votre consentement); ou
          </p>
        </li>
        <li>
          <p>
            lorsque vous nous avez donné votre consentement (dans les cas où
            votre consentement est réellement donné librement).
          </p>
        </li>
      </ul>

      <p>
        Dans la mesure où nous nous fondons sur le consentement pour collecter
        et traiter des Informations relatives au Candidat, vous êtes en droit de
        refuser de donner votre consentement ou de retirer votre consentement à
        tout moment en nous envoyant un courriel à l’adresse{' '}
        <Link href='mailto:people-privacy@plaid.com'>
          <a>people-privacy@plaid.com</a>
        </Link>
        . Le retrait de votre consentement n’affectera toutefois pas la légalité
        de tout traitement que nous avons effectué avant votre retrait, ni le
        traitement de vos données à caractère personnel à d’autres fins menées
        sur la base de motifs de traitement légaux autres que le consentement.
      </p>

      <h5 id='nos-pratiques-de-conservation-confidentialité-du-Candidat'>
        Nos pratiques de conservation
      </h5>
      <p>
        Nous conservons les Informations relatives au Candidat uniquement le
        temps nécessaire à la réalisation de la finalité pour laquelle elles ont
        été collectées et utilisées, conformément au présent Avis, à moins
        qu’une période de conservation plus longue ne soit requise ou autorisée
        par la loi applicable. Comme indiqué ci-dessus, cependant, si vous
        acceptez un emploi chez Plaid, vos Informations relatives au Candidat
        feront partie de votre dossier d’emploi et seront utilisées à des fins
        d’emploi conformément à la loi applicable et à tout Avis de
        confidentialité du personnel applicable.
      </p>

      <h4 id='autres-informations-confidentialité-du-Candidat'>
        Autres informations
      </h4>

      <h5 id='transferts-internationaux-de-données-confidentialité-du-Candidat'>
        Transferts internationaux de données
      </h5>
      <p>
        Nous exerçons nos activités à l’international et, par conséquent, nous
        transférerons les Informations relatives au Candidat au-delà des
        frontières internationales, notamment depuis le Royaume-Uni, l’EEE et/ou
        le Canada vers les États-Unis à des fins de traitement et de stockage.
        Dans la mesure où les Informations relatives au Candidat sont
        transférées du Royaume-Uni ou de l’EEE vers des territoires/pays dans
        lesquels la Commission européenne et/ou le Secrétaire d’état du
        Royaume-Uni (le cas échéant) a estimé que le cadre juridique de ce
        territoire/pays n’offrait pas une protection adéquate pour les droits et
        les libertés des personnes en matière de données personnelles, nous
        transférerons ces données en conformité avec les lois applicables en
        matière de protection des données, notamment en utilisant les clauses
        contractuelles types approuvées (le cas échéant) par la Commission
        européenne et/ou le Secrétaire d’état du Royaume-Uni (le cas échéant).
        Vous pouvez demander une copie de ces clauses contractuelles types en
        nous contactant comme indiqué ci-dessous.
      </p>
      <p>
        En outre, nous nous engageons à nous conformer à toutes les exigences ou
        directives supplémentaires de la Cour de justice de l’Union européenne,
        de la législation applicable en matière de protection des données ou des
        autorités de contrôle en ce qui concerne le transfert de données à
        caractère personnel.
      </p>

      <h5 id='droits-de-protection-des-données-des-candidats-californiens'>
        Droits de protection des données des candidats californiens
      </h5>
      <p>
        La loi californienne sur la protection de la vie privée des
        consommateurs, ou « CCPA », telle que modifiée par la loi californienne
        sur les droits à la protection de la vie privée, accorde aux candidats
        résidant en Californie certains droits en ce qui concerne leurs
        informations relatives au Candidat. Si vous résidez en Californie, cette
        section s’applique à vous.
      </p>
      <p>
        Nous collectons, ou avons collecté au cours des 12 mois précédents, les
        catégories d’Informations relatives au Candidat énumérées dans le
        tableau ci-dessous à partir des sources identifiées dans la section «
        Informations que nous collectons ». Pour plus de détails sur les points
        de données précis que nous collectons ou avons collectés au cours des 12
        derniers mois, veuillez consulter la section « Informations que nous
        collectons » ci-dessus. Nous utilisons et divulguons les Informations
        relatives au Candidat à des fins commerciales et d’affaires énumérées
        dans le tableau suivant, et nous divulguons les Informations relatives
        au Candidat aux destinataires également énumérés dans le tableau
        suivant.
      </p>
      <Image
        src='/assets/img/legal/candidate-privacy-notice/candidate-information-table-fr@2x.png'
        alt="Tableau d'informations sur le candidat"
        isLazy={false}
      />
      <p>
        Nous conservons les catégories d’Informations relatives au Candidat
        conformément aux pratiques de conservation décrites ci-dessus dans{' '}
        <Link href='#nos-pratiques-de-conservation-confidentialité-du-Candidat'>
          <a>Nos pratiques de conservation</a>
        </Link>
        .
      </p>
      <p>
        Plaid (1) ne « vend » ni ne « partage » (tels que ces termes sont
        définis par la CCPA) d’Informations relatives au Candidat ou (2)
        n’utilise ou ne divulgue pas d’informations personnelles sensibles à
        d’autres fins que celles spécifiées dans la section 1798.121(a) de la
        CCPA.
      </p>
      <p>
        Sous réserve de certaines limitations, vous avez le droit de (a)
        demander à en savoir plus sur les sources et les catégories et éléments
        spécifiques des Informations relatives au Candidat que nous collectons,
        utilisons et divulguons, ainsi que sur les catégories de tiers auxquels
        nous divulguons ces informations, (b) demander la suppression des
        Informations relatives au Candidat, (c) demander la correction des
        Informations relatives au Candidat inexactes, et (d) ne pas faire
        l’objet de discrimination pour l’exercice de ces droits. Vous pouvez
        faire ces demandes en nous envoyant un e-mail à people-privacy@plaid.com
        en remplissant ce{' '}
        <Link href='https://my.plaid.com/data-subject-request-form-fr/'>
          <a> formulaire en ligne</a>
        </Link>{' '}
        ou en appelant le (415) 799 - 1354. Nous vérifierons votre demande en
        vous demandant de fournir des informations relatives à vos interactions
        récentes avec nous, telles que votre numéro de téléphone et votre
        adresse e-mail. Nous ne vous discriminerons pas si vous exercez vos
        droits en vertu de la CCPA.
      </p>
      <p>
        Si nous recevons votre demande d’un agent autorisé qui ne fournit pas de
        procuration valide, nous pouvons demander à l’agent autorisé de fournir
        la preuve que vous avez donné à l’agent l’autorisation signée de
        soumettre la demande d’exercice des droits en votre nom. En l’absence
        d’une procuration valide, nous pouvons également vous demander de
        vérifier votre propre identité directement auprès de nous ou de nous
        confirmer que vous avez autrement donné à l’agent autorisé
        l’autorisation de soumettre la demande. Si vous êtes un agent autorisé
        qui souhaite faire une demande, veuillez nous envoyer un e-mail à{' '}
        <Link href='mailto:people-privacy@plaid.com'>
          <a>people-privacy@plaid.com</a>
        </Link>
        .
      </p>

      <h5 id='droits-de-protection-des-données-des-candidats'>
        Droits de protection des données des candidats au Royaume-Uni, dans
        l’EEE et au Canada
      </h5>
      <p>
        En vertu de la loi en vigueur, vous disposez de certains droits en ce
        qui concerne vos Informations relatives au Candidat. Ces droits peuvent
        varier selon le pays et la province.
      </p>
      <p>
        Sous réserve de certaines limitations et exceptions, ces droits incluent
        le droit de : (i) savoir si nous traitons des données à caractère
        personnel vous concernant ; (ii) demander l’accès ou la rectification
        des données à caractère personnel que nous traitons à votre sujet ;
        (iii) s’opposer à, ou demander à ce que nous limitions, le traitement de
        vos données à caractère personnel ; (iv) nous demander de supprimer les
        données à caractère personnel vous concernant ; (v) nous demander de
        fournir les données à caractère personnel que vous nous avez fournies de
        manière structurée, dans un format couramment utilisé et lisible par
        machine, pour transmission à un autre responsable du traitement ; (vi)
        révoquer votre consentement à tout moment lorsque notre traitement est
        basé sur votre consentement ; et (vii) introduire une réclamation auprès
        de votre autorité de contrôle locale (si vous êtes au Royaume-Uni,
        veuillez consulter cette{' '}
        <Link href='https://ico.org.uk/global/contact-us/'>
          <a>page</a>
        </Link>{' '}
        pour les coordonnées du bureau du Commissaire à l’information et si vous
        êtes dans l’EEE, veuillez consulter cette{' '}
        <Link href='https://edpb.europa.eu/about-edpb/board/members_en'>
          <a>page</a>
        </Link>{' '}
        pour les coordonnées des autorités de contrôle de l’UE).
      </p>
      <p>
        Si vous souhaitez exercer un quelconque de vos droits, veuillez le cas
        échéant nous contacter en utilisant les données de contact fournies
        ci-après.
      </p>
      <p>
        En outre, nous serons heureux de vous fournir un aperçu plus détaillé de
        nos finalités de traitement pertinentes (ainsi que des catégories de
        données associées, des périodes de conservation et des motifs juridiques
        de traitement) à votre demande.
      </p>

      <h5 id='modifications-apportées-au-présent-avis-confidentialité-du-Candidat'>
        Modifications apportées au présent Avis
      </h5>
      <p>
        Nous pouvons modifier le présent Avis de confidentialité du Candidat de
        temps à autre. Si nous apportons des modifications, nous mettrons à jour
        la Date d’entrée en vigueur en haut du présent Avis. En outre, si l’un
        des changements est important et a un impact sur vos Informations
        relatives au Candidat, nous vous en enverrons également une copie par
        e-mail.
      </p>

      <h5 id='contacter-plaid-confidentialité-du-Candidat'>Contacter Plaid</h5>
      <p>
        Si vous avez des questions concernant le présent Avis de confidentialité
        du Candidat, nos pratiques de confidentialité ou les Informations
        relatives au Candidat que nous recueillons à votre sujet, ou si vous
        avez des demandes concernant ces Informations relatives au Candidat,
        vous pouvez nous contacter à l’adresse{' '}
        <Link href='mailto:people-privacy@plaid.com'>
          <a>people-privacy@plaid.com</a>
        </Link>{' '}
        ou par courrier à l’adresse:
      </p>
      <p>
        <em>
          Si vous postulez à un emploi chez Plaid Inc. (situé aux États-Unis):
        </em>
      </p>
      <p>
        Plaid Inc. <br />
        À l’attention de : Service juridique <br />
        PO Box 7775 #35278 <br />
        San Francisco, California 94120-7775, États-Unis.
      </p>
      <p>
        <em>
          Si vous postulez à un emploi chez Plaid Financial Ltd. (situé au
          Royaume-Uni):
        </em>
      </p>
      <p>
        Plaid Financial Ltd. <br />
        À l’attention de : Service juridique <br />
        New Penderel House, 4th Floor <br />
        283-288 High Holborn <br />
        London, Royaume-Uni, WC1V 7HP
      </p>
      <p>
        <em>
          Si vous postulez à un emploi chez Plaid, B.V. (situé aux Pays-Bas):
        </em>
      </p>
      <p>
        Plaid, B.V. <br />
        À l’attention de : Service juridique <br />
        Muiderstraat 1 <br />
        1011 PZ Amsterdam, Pays-Bas
      </p>

      <hr className='section-divider' />
    </>
  );
};

propTypes.FrVersion = PropTypes;
export default FrVersion;
